import path from 'node:path'
import * as p from '@clack/prompts'
import type { ListPresetsCommandOptions } from '@core-engine/commands/runtime.js'
import { resolveConfig } from '@next-adapter/config.js'
import { listAvailablePresets } from '@next-adapter/preset-runtime.js'

export async function runListPresetsCommand(options: ListPresetsCommandOptions): Promise<void> {
  const cwd = options.cwd ? path.resolve(options.cwd) : process.cwd()
  const config = await resolveConfig(cwd)
  const installedPresets = new Set(config.presets.installed)

  const lines = listAvailablePresets().map((preset) => {
    const status = installedPresets.has(preset.id) ? 'installed' : 'available'
    return `${preset.id.padEnd(10)} ${status.padEnd(10)} ${preset.kind.padEnd(12)} ${preset.description}`
  })

  p.note(lines.join('\n'), 'BetterStart presets')
  p.outro(`${installedPresets.size} installed, ${lines.length - installedPresets.size} available`)
}
